import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./meterActions";
import { userLogoutReceived } from "../../../security";
import { setBTUMeterModelReceived } from "./meterActions";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: null,
  btuMeters: [],
  electricalMeters: [],
  meters: []
});

//is action payload immutable?
const meterReducer = handleActions(
  {
    [combineActions(
      Actions.fetchBtuMetersRequested,
      Actions.fetchMetersRequested,
      Actions.fetchElectricalMetersRequested
    )](state) {
      return state.set("isFetchingData", true);
    },
    [combineActions(
      Actions.fetchBTUMetersFailed,
      Actions.fetchMetersFailed,
      Actions.fetchElectricalMetersFailed
    )](state, action) {
      return state.set("isFetchingData", false).set("error", action.payload);
    },
    [combineActions(
      Actions.setBTUMeterModelFailed,
      Actions.bulkEditMetersFailed
    )](state, action) {
      return state.set("error", action.payload);
    },
    [Actions.fetchBtuMetersReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("btuMeters", Immutable.fromJS(action.payload));
    },
    [Actions.fetchMetersReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("meters", Immutable.fromJS(action.payload));
    },
    [Actions.fetchElectricalMetersReceived](state, action) {
      return state
        .set("isFetchingData", false)
        .set("electricalMeters", Immutable.fromJS(action.payload));
    },
    [userLogoutReceived](state, action) {
      return initialState;
    },
    [setBTUMeterModelReceived](state, action) {
      const { meterSerialNumber, model } = action.payload;
      return state
        .update("meters", meters => {
          const index = meters.findIndex(meter => {
            return meter.get("meterSerialNumber") === meterSerialNumber;
          });
          return meters.update(index, meter => {
            return meter && meter.set("model", model);
          });
        })
        .update("btuMeters", btuMeters => {
          const index = btuMeters.findIndex(btuMeter => {
            return btuMeter.get("meterSerialNumber") === meterSerialNumber;
          });
          return btuMeters.update(index, btuMeter => {
            return btuMeter && btuMeter.set("model", model);
          });
        });
    }
  },
  initialState
);

export { meterReducer };
export default meterReducer;



// WEBPACK FOOTER //
// ./src/features/meter/store/meterReducer.js